<template>
    <div class="absolute inset-0 bg-black/50 flex justify-center items-center z-50">
        <div class="bg-white rounded-2xl shadow-xl w-11/12 max-w-sm p-6 flex flex-col items-center animate-fade-in">
            <!-- Success Icon -->
            <div class="w-16 h-16 rounded-full bg-green-100 flex justify-center items-center mb-4">
                <svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
            </div>

           
            <h2 class="text-xl font-semibold text-gray-800 mb-2">
                {{ $t('phoneConfirmation.successTitle') }}
            </h2>
            <p class="text-gray-600 text-center mb-4">
                {{ $t('phoneConfirmation.successMessage') }}
            </p>

         
            <button @click="goToProfile()"
                class="bg-green-600 hover:bg-green-700 text-white font-medium px-5 py-2 rounded-lg shadow transition duration-200">
                {{ $t('phoneConfirmation.go_to_profile') }}
            </button>
        </div>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();
const goToProfile = () => {
    router.push({ name: 'edit-info' });
};
</script>